/**
 * Created by Andy on 9/9/17.
 */
import React, {Component} from 'react';

class NotFound extends Component {

    render() {
        return (
            <h1>404 Page not found!</h1>
        )
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/NotFound.js